// src/components/Feeding/FeedingTabRedirect.jsx
//
// I-03 S3-07.1 (Fable ruling 6) — the four old feeding routes REDIRECT to
// their tab on the one Feeding page, and every query parameter they were
// given rides along (Feeding History's `include_voided`, the plan's
// `start` / `days` / `group`). `replace`, so Back does not bounce the
// keeper into the redirect again.
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { feedingHref } from '../../utils/feedingHref';

export default function FeedingTabRedirect({ tab }) {
  const { facilityId } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`${feedingHref(facilityId, tab, search)}${hash || ''}`} replace />;
}

FeedingTabRedirect.propTypes = {
  tab: PropTypes.oneOf(['plan', 'history', 'foods', 'profiles']).isRequired,
};
